import {
  type DoorInfo,
  type ExamRoomRequestPhysicalAttributes,
  type FeatureCheck,
  type PhotoSet,
} from '@exam-center/graphql';

export const mapPhysicalInfoToDefaultValues = (info?: ExamRoomRequestPhysicalAttributes | null) => {
  if (!info) return undefined;
  const mapFeatureCheck = (featureCheck?: FeatureCheck | null) =>
    featureCheck
      ? {
          valid: Boolean(featureCheck.valid),
          additionalInfo: featureCheck.additionalInfo ?? undefined,
          images: featureCheck.images ?? [],
        }
      : undefined;
  const mapPhotoSet = (photoSet?: PhotoSet | null) =>
    photoSet ? { images: photoSet.images ?? [] } : undefined;
  const mapDoorInfo = (doorInfo?: DoorInfo | null) =>
    doorInfo && typeof doorInfo.numberOfDoors === 'number' && doorInfo.numberOfDoors > 0
      ? { numberOfDoors: doorInfo.numberOfDoors, images: doorInfo.images ?? [] }
      : undefined;

  return {
    seatSideSpacing: mapFeatureCheck(info.seatSideSpacing),
    screenDistance: mapFeatureCheck(info.screenDistance),
    seatFrontBackSpacing: mapFeatureCheck(info.seatFrontBackSpacing),
    windows: mapFeatureCheck(info.windows),
    storageLocker: mapFeatureCheck(info.storageLocker),
    examineeStorage: mapFeatureCheck(info.examineeStorage),
    securityCameras: mapFeatureCheck(info.securityCameras),
    entryExitDoors: mapDoorInfo(info.entryExitDoors),
    frontOfExamRoom: mapPhotoSet(info.frontOfExamRoom),
    insideExamRoom: mapPhotoSet(info.insideExamRoom),
    registrationArea: mapFeatureCheck(info.registrationArea),
    toilets: mapFeatureCheck(info.toilets),
    sharedOpenArea: mapFeatureCheck(info.sharedOpenArea),
  };
};
